import React, { useEffect } from "react";
import { Provider, useDispatch } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import store from "./store";
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import SearchResults from "./features/search/SearchResults";
import MovieDetail from "./features/movie/MovieDetail";
import CastPage from "./features/cast/CastPage";
import LikesPage from "./features/likes/LikesPage";
import WishlistPage from "./features/wishlist/WishlistPage";
import WatchListPage from "./features/watchlist/WatchListPage";
import { loadLikes } from "./features/likes/likesActions";
import { loadWishlist } from "./features/wishlist/wishlistActions";
import { loadWatchlist } from "./features/watchlist/watchlistActions";

function AppContent() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadLikes());
    dispatch(loadWishlist());
    dispatch(loadWatchlist());
  }, [dispatch]);

  return (
    <>
      <Navbar />
      <div className="main-content">
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/search" component={SearchResults} />
          <Route exact path="/movie/:id" component={MovieDetail} />
          <Route exact path="/movie/:id/cast" component={CastPage} />
          <Route exact path="/likes" component={LikesPage} />
          <Route exact path="/wishlist" component={WishlistPage} />
          <Route exact path="/watchlist" component={WatchListPage} />
        </Switch>
      </div>
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
